import { RequestGatewayPlugin } from "../../../type";
import { isProd, isServer } from "../../../utils";

export const replaceBaseUrlPlugin: RequestGatewayPlugin = {
  name: "replaceBaseUrlPlugin",
  type: "request",
  apply(config, options) {
    const { baseUrl, gatewayUrl } = options;
    if (
      isServer() &&
      isProd &&
      !config.isDemoTrading &&
      !Number(config.headers?.isDemoTrading)
    ) {
      config.url = config.url?.replace(baseUrl, gatewayUrl);
    }

    return config;
  },
};
